import $ from "jquery";

function showElement($el) {
  $el.removeClass("visually-hidden").attr("aria-hidden", "false");
}

function hideElement($el) {
  $el.addClass("visually-hidden").attr("aria-hidden", "true");
}

$(document).on("change", ".switch-member-input", function () {
  const $changed = $(this);
  const data = $changed.data("toggle-switch-member-options");
  if (!data) return;

  const productId = data.product_id;
  $(`input[name='switch-member-${productId}']`).removeClass("checked");
  $changed.addClass("checked");

  const selectedIsDefault =
    $changed.attr("id") === "switch-member-" + data.variation_id_default;

  applyMembershipSelection(selectedIsDefault);

  setTimeout(computeAndRenderTotal, 0);

  $(".calc-btn").removeClass("disabled");

  setTimeout(updatePriceVisibility, 0);
  setTimeout(updateProceedToCartLink, 0);
});

function applyMembershipSelection(useDefault) {
  $(".switch-member-input").each(function () {
    const $radio = $(this);
    const d = $radio.data("toggle-switch-member-options");
    if (!d) return;

    const targetId = useDefault
      ? "switch-member-" + d.variation_id_default
      : "switch-member-" + d.variation_id;

    const $group = $(`input[name='switch-member-${d.product_id}']`);
    $group.prop("checked", false);
    $group.removeClass("checked");

    $("#" + targetId)
      .prop("checked", true)
      .addClass("checked")
      .trigger("input");

    const discountedPrice = useDefault ? d.price_raw : d.variation_price_raw;
    const preCouponPrice = useDefault
      ? d.price_pre_coupon_raw
      : d.variation_price_pre_coupon_raw;
    const variationId = useDefault ? d.variation_id_default : d.variation_id;

    const $allProductInputs = $(`.product_${d.product_id}`);

    $allProductInputs
      .val(discountedPrice)
      .attr("value", discountedPrice)
      .attr("data-price", discountedPrice)
      .attr("data-pre-coupon-price", preCouponPrice)
      .attr("data-variation", variationId)
      .trigger("change", [{ source: "membership" }]);

    const $baseProductInputs = $(`.base-product.product_${d.product_id}`);

    $baseProductInputs
      .val(discountedPrice)
      .attr("value", discountedPrice)
      .attr("data-price", discountedPrice)
      .attr("data-pre-coupon-price", preCouponPrice)
      .attr("data-variation", variationId)
      .trigger("change", [{ source: "membership" }]);
  });
}

$(function () {
  $(".switch-member-input").prop("checked", false).removeClass("checked");

  $(".calc-btn").each(function () {
    if ($(this).find(".switch-member-input").length === 0) {
      $(this).addClass("disabled");
    }
  });

  $(".calc-enroll-btn").addClass("disabled");

  computeAndRenderTotal();
  updatePriceVisibility();
  updateProceedToCartLink();
});

$(document).on("change", ".base-product", function (e, meta) {
  if (meta && meta.source === "membership") return;

  const $changed = $(this);

  const baseName = $changed.attr("name");
  if (baseName) {
    $(`input[name='${baseName}'].base-product`).removeClass("checked");
  }
  $changed.addClass("checked");

  const dataAddons = $changed.data("addons");

  if (!dataAddons) {
    $(".addon-product").each(function () {
      hideElement($(this));
    });
  } else {
    const addonIds = String(dataAddons)
      .split(",")
      .map((id) => id.trim());

    $(".addon-product").each(function () {
      const $addon = $(this);
      const match = $addon.attr("class")?.match(/product_(\d+)/);
      const id = match ? match[1] : null;

      if (id && addonIds.includes(id)) {
        showElement($addon);
      } else {
        hideElement($addon);
      }
    });
  }

  $(".calc-enroll-btn").removeClass("disabled");

  updatePriceVisibility();
  updateProceedToCartLink();
});

$(function () {
  const $firstBase = $(".base-product").first();
  if ($firstBase.length) {
    const dataAddons = $firstBase.data("addons");

    if (!dataAddons) {
      $(".addon-product").each(function () {
        hideElement($(this));
      });
    } else {
      const addonIds = String(dataAddons)
        .split(",")
        .map((id) => id.trim());

      $(".addon-product").each(function () {
        const $addon = $(this);
        const match = $addon.attr("class")?.match(/product_(\d+)/);
        const id = match ? match[1] : null;

        if (id && addonIds.includes(id)) {
          showElement($addon);
        } else {
          hideElement($addon);
        }
      });
    }
  }
});

function toNumber(v) {
  if (v == null) return 0;
  const clean = String(v).replace(/[^0-9.\-]/g, "");
  const n = parseFloat(clean);
  return isNaN(n) ? 0 : n;
}

function formatCurrency(amount, $el) {
  const $ref = $el && $el.length ? $el.first() : $(".total-price").first();
  const locale = $ref.data("locale") || "en-US";
  const currency = $ref.data("currency") || "USD";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(amount);
  } catch (e) {
    return "$" + amount.toFixed(2);
  }
}

function preCouponOf($el) {
  const preCouponAttr = $el.attr("data-pre-coupon-price");
  if (preCouponAttr !== undefined) {
    return toNumber(preCouponAttr);
  }

  const regularAttr = $el.attr("data-price");
  if (regularAttr !== undefined) {
    return toNumber(regularAttr);
  }

  return toNumber($el.val());
}

function computeAndRenderTotal() {
  let discountTotal = 0;
  let preCouponTotal = 0;

  $(".base-product:checked").each(function () {
    const $el = $(this);

    discountTotal += toNumber($el.val());
    preCouponTotal += preCouponOf($el);
  });

  $(".addon-product input[type='radio']:checked").each(function () {
    const $el = $(this);

    const addonName = $el.attr("name");
    if (addonName) {
      $(`input[name='${addonName}']`).removeClass("checked");
    }
    $el.addClass("checked");

    discountTotal += toNumber($el.val());
    preCouponTotal += preCouponOf($el);
  });

  const $discountPrice = $(".discount-price");
  const hasDiscountDisplay = $discountPrice.length > 0;

  $(".total-price").html(
    formatCurrency(
      hasDiscountDisplay ? preCouponTotal : discountTotal,
      $(".total-price")
    )
  );
  $discountPrice.html(formatCurrency(discountTotal, $discountPrice));
}

$(document).on("change", ".base-product", function () {
  computeAndRenderTotal();
});

$(document).on("change", ".addon-product input[type='radio']", function () {
  const $el = $(this);
  const addonName = $el.attr("name");
  if (addonName) {
    $(`input[name='${addonName}']`).removeClass("checked");
  }
  $el.addClass("checked");
  computeAndRenderTotal();
});

$(document).on("change", ".switch-member-input", function () {
  computeAndRenderTotal();
});

function updateProceedToCartLink() {
  const selectedIds = [];

  $(".base-product:checked").each(function () {
    const match = $(this).attr("data-variation")?.match(/(\d+)/);
    if (match) selectedIds.push(match[1]);
  });

  $(".addon-product input[type='radio'].addon-yes:checked").each(function () {
    const $addon = $(this).closest(".addon-product");
    const match = $addon.attr("class")?.match(/product_(\d+)/);
    if (match) {
      selectedIds.push(match[1]);
    }
  });

  const query = selectedIds.length ? `?add-to-cart=${selectedIds.join(",")}` : "";

  $(".calc-enroll-btn").attr("href", `/checkout/${query}`);

  if (!selectedIds.length) {
    $(".calc-enroll-btn").addClass("disabled");
  }
}

$(document).on(
  "change",
  ".base-product, .addon-product input[type='radio']",
  function () {
    updateProceedToCartLink();

    const hasProductSelected = $(".base-product:checked").length > 0;
    if (hasProductSelected) {
      $(".calc-enroll-btn").removeClass("disabled");
    } else {
      $(".calc-enroll-btn").addClass("disabled");
    }
  }
);

$(document).on("change", ".switch-member-input", function () {
  setTimeout(updateProceedToCartLink, 0);
});

function updatePriceVisibility() {
  const hasMembershipSelected = $(".switch-member-input:checked").length > 0;

  const hasProductSelected = $(".base-product:checked").length > 0;

  if (hasMembershipSelected && hasProductSelected) {
    showElement($(".set-price"));
    showElement($(".discount-badge"));
    hideElement($(".zero-price"));
  } else {
    hideElement($(".set-price"));
    hideElement($(".discount-badge"));
    showElement($(".zero-price"));
  }
}

$(document).on("change", ".switch-member-input, .base-product", function () {
  updatePriceVisibility();
});
